import { inject, Injectable } from '@angular/core';
import { BaseFlowsStore } from '@kinet-open-network/client/flows/data-access';
import { OrderStatus } from '@kinet-open-network/shared/data-access/model';
import {
  FlowGoodsReceipts,
  FlowGoodsReceiptsStepData,
} from './flow-goods-receipts.model';
import { FlowGoodsReceiptsService } from './flow-goods-receipts.service';

@Injectable()
export class FlowGoodsReceiptsStore extends BaseFlowsStore<
  FlowGoodsReceipts,
  'id',
  FlowGoodsReceiptsStepData
>(FlowGoodsReceiptsService) {
  override readonly service = inject(FlowGoodsReceiptsService);

  override isTerminalState(status: string): boolean {
    return status === OrderStatus.delivered;
  }
}
